export default __webpack_public_path__ + "static/media/4bc7539ba2bb72aec8c07d7007b8ad61.png";